<template>
  <div class="index-root">
    <div :class="['navigation', {'hidden': isScrollingForward && !promo}, {'transparent': !!promo}]">
      <div class="logo" @click="closePromo">
        <img src="../static/images/logo_white.svg" alt="ЛаЛаЛэнд">
      </div>
      <div class="navigation-buttons">
        <button v-if="promo" @click="closePromo" class="button close-promo">
          <font-awesome-icon icon="times" fixedWidth /> закрыть
        </button>
        <router-link v-else class="button" to="/journal">личный кабинет</router-link>
      </div>
    </div>
    <BaseSpinner v-if="isPending" />
    <PromoPage v-else-if="promo" :promo="promo" />
    <LandingPage v-else-if="texts" class="root-content" :texts="texts" />
  </div>
</template>

<script>
import axios from 'axios'

import LandingPage from '@/components/landing/LandingPage.vue'
import PromoPage from '@/components/PromoPage.vue'

import useScrollDirection from '@/composables/useScrollDirection'
import { getErrors } from '@/errors'

export default {
  name: 'IndexRoot',

  components: {
    LandingPage,
    PromoPage
  },

  setup () {
    const isScrollingForward = useScrollDirection()

    return {
      isScrollingForward
    }
  },

  data () {
    return {
      texts: null,
      promos: null,
      isPending: false,

      promoIndex: 0
    }
  },

  created () {
    this.fetchData()
  },

  computed: {
    promo () {
      if (!this.promos) return
      return this.promos[this.promoIndex]
    }
  },

  methods: {
    fetchData () {
      this.isPending = true

      axios.all([
        axios.get('/api/landing/'),
        axios.get('/api/landing-promos/')
      ])
        .then(([texts, promos]) => {
          this.texts = texts.data
          this.promos = promos.data
        }, error => {
          this.$toast.error(getErrors(error).detail)
        })
        .then(() => {
          this.isPending = false
        })
    },

    closePromo () {
      if (this.promo) {
        this.promoIndex++
      }
    }
  }
}
</script>

<style scoped>
.index-root {
  display: flex;
  flex-direction: column;

  min-height: 100vh;
}

.root-content {
  flex: 1;

  display: flex;
  flex-direction: column;
}

.navigation {
  position: fixed;
  z-index: 3;
  top: 0;

  display: flex;

  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 3em;

  padding: 0 1em 0 1em;

  background-color: var(--green);

  transition: transform 0.3s;
}

.navigation.hidden {
  transform: translateY(-3em);
}

.navigation.transparent {
  background: none;
}

.navigation .logo {
  height: 100%;

  padding: 1em;

  cursor: pointer;
}

.navigation .logo img {
  height: 0.9em;
}

.button.close-promo {

}
</style>
